import { Grid } from '@mui/material';
import ActionButton from 'components/buttons/index';
import OutlinedInput from 'components/inputs/outlined-input';
import { styles } from './styles';
import { useState } from 'react';

interface IVariantLibraryOptionCreateInput {
  onSubmit: (value: string) => void;
}

export const VariantLibraryOptionCreateInput = ({ onSubmit }: IVariantLibraryOptionCreateInput) => {
  const [optionName, setOptionName] = useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOptionName(e.target.value);
  };

  const handleSubmit = () => {
    if (!optionName) return;

    onSubmit(optionName);
    setOptionName('');
  };

  return (
    <Grid sx={styles.container}>
      <OutlinedInput
        fullWidth
        name="name"
        placeholder="Add new"
        value={optionName}
        onChange={onChange}
      />
      <ActionButton
        disabled={!optionName}
        label="Add"
        type="button"
        variant="primary"
        style={{ width: 104 }}
        onClick={handleSubmit}
      />
    </Grid>
  );
};
